import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import AuditActions from "@/components/audit/AuditActions";
import { TableSkeleton } from "@/components/ui/Skeleton";
import { trpc } from "@/lib/trpc";
import { useAuditAccountId } from "./$orgSlug.audit";

// The Actions tab: what was applied to the account, by whom and when.
export const Route = createFileRoute("/_authenticated/$orgSlug/audit/actions")({
  component: ActionsTab,
});

function ActionsTab() {
  const { orgSlug } = Route.useParams();
  const accountId = useAuditAccountId();
  // The runner applies between visits; keep the list fresh while open.
  const { data } = useQuery({
    ...trpc.audit.actions.queryOptions({ orgSlug, accountId }),
    refetchInterval: 30_000,
  });
  return data ? (
    <AuditActions orgSlug={orgSlug} actions={data.actions} />
  ) : (
    <TableSkeleton label="Loading Actions" rows={6} columns={5} />
  );
}
